import { render, staticRenderFns } from "./AutenticacaoDoisFatores.vue?vue&type=template&id=5598254b&scoped=true&"
import script from "./AutenticacaoDoisFatores.vue?vue&type=script&lang=js&"
export * from "./AutenticacaoDoisFatores.vue?vue&type=script&lang=js&"
import style0 from "./AutenticacaoDoisFatores.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AutenticacaoDoisFatores.vue?vue&type=style&index=1&id=5598254b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598254b",
  null
  
)

export default component.exports